import initGeo from './utilities/geo';
import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';

import initCookies from './components/cookies';
import initOverlays from './components/overlays';
import initCarousels from './components/carousels';
import initVideoEmbeds from './components/videos';

initCookies();
initGeo();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const overlayEls = document.querySelectorAll('.js-overlay-toggle');

if (overlayEls && overlayEls.length > 0) {
    initOverlays(overlayEls);
}

const carouselEls = document.querySelectorAll('.js-carousel');

if (carouselEls && carouselEls.length > 0) {
    initCarousels(carouselEls);
}

const videoEls = document.querySelectorAll('.js-video-embed');

if (videoEls && videoEls.length > 0) {
    initVideoEmbeds(videoEls);
}

// YOLO LA~ZY
const filterToggle = document.querySelector('.js-filters-toggle');

if (filterToggle) {
    const html = document.documentElement;
    window.filterOpen = false;

    filterToggle.addEventListener('click', (event) => {
        event.preventDefault();

        window.filterOpen = !window.filterOpen;

        if (window.filterOpen) {
            html.classList.add('filter-open');
        } else {
            html.classList.remove('filter-open');
        }
    });
}
